<template>
  <div>
    <div class="title">{{activityTitle}}</div>
    <!-- <div class="sub-title">{{customerName}}</div> -->

    <refresh-list @onLoad="onLoad" :list="list" @onRefresh="init" ref="refreshList">
      <div class="card-content-lsy" v-for="(item, index) in list" :key="index">
        <div class="dealer-title">
          <span>{{item.storeName}}</span>
          <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 200 200" preserveAspectRatio="none" shape-rendering="auto">
            <defs>
              <path id="gentle-wave" d="M-.5,8.5c13,0,63-7,80-7s42,7,70,7c30,0,63-7,84-7s58,7,83,7,58-7,83-7v398H-.5Z" />
              <linearGradient id="orange_red" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style="stop-color:#FFF9F6; stop-opacity:0.4"/>
                <stop offset="100%" style="stop-color:#FFF0EA; stop-opacity:1"/>
              </linearGradient>
            </defs>
            <g class="parallax">
              <use xlink:href="#gentle-wave" x="-60" y="7" fill="url(#orange_red)" />
              <use xlink:href="#gentle-wave" x="-40" y="12" fill="#FFF0EA" />
            </g>
          </svg>
        </div>
        <div class="card-inner">
          <div class="card-text grid-item">
            <div class="orange">{{item.browseNumber}}</div>
            <div class="desc">浏览次数</div>
          </div>
          <div class="card-text grid-item">
            <div class="orange">{{item.browsePeopleNumber}}</div>
            <div class="desc">浏览人数</div>
          </div>
          <div class="card-text grid-item">
            <div class="orange">{{item.shareNumber}}</div>
            <div class="desc">二次分享</div>
          </div>
          <div class="card-text grid-item">
            <div class="orange">{{item.signUpNumber}}</div>
            <div class="desc">报名人数</div>
          </div>
        </div>
        <div class="card-footer">
          <div class="card-btn link-item" @click="to(item, '/stuff')">
            <span class="desc">职员</span>
            <span class="orange">({{item.staffNumber}})</span>
          </div>
          <div class="card-btn link-item" @click="to(item, '/user')">
            <span class="desc">用户</span>
            <span class="orange">({{item.customerNumber}})</span>
          </div>
        </div>
      </div>
    </refresh-list>
    
  </div>
</template>

<script>
import refreshList from '@/components/refresh-list/refresh-list'
export default {
  components: {
    refreshList
  },
  data() {
    return {
      list: [],
      pageNum: 1,
      pageSize: 20,
    }
  },
  computed: {
    activityId() {
      return this.$route.query.activityId
    },
    activityTitle() {
      return this.$route.query.activityTitle
    },
    customerId() {
      return this.$route.query.customerId
    },
    customerName() {
      return this.$route.query.customerName
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    onLoad() {
      this.getList();
    },
    init() {
      this.pageNum = 1;
      this.list = [];
      this.getList();
    },
    getList() {
      let data = {
        filterData: {
          activityId: this.activityId,
          customerId: this.customerId
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$api.h5.queryStoreActivityStatisticList(data)
      .then(res=>{
        if(res.code == 200) {
          this.list.push(...res.data.list);
          this.pageNum = res.data.pageNum + 1;
          this.$refs['refreshList'].complete(res.data);
        }else{
          this.$refs['refreshList'].onFinish();
        }
      })
      .catch(err=>{
        this.$refs['refreshList'].onFinish();
      })
    },
    to(item, p) {
      this.$router.push({
        path: p,
        query: {
          storeName: item.storeName,
          storeCode: item.storeCode,
          ...this.$route.query,
          enterType: item.enterType,
          enterPrimaryKey: item.enterPrimaryKey
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .title
    font-size 16px
    font-weight bold
    color #333333
    margin 10px 15px

  .sub-title
    font-size 14px
    color #666
    margin 10px 15px

  .grid-item
    text-align center
    .orange
      color #FF6B31
      font-size 18px
      font-weight bold
    .desc
      font-size 12px
      color #666666

  .link-item
    .desc
      font-size 14px
      color #666666
    .orange
      color #FF6B31
      font-size 14px

  .dealer-title
    color #FF6B31
    font-size 14px
    font-weight bold
    height 40px
    line-height 40px
    padding 0 15px
    span 
      position relative
      z-index 2
  
  .waves
    transform rotate(176deg)
    position absolute
    left -12px
    right 0
    top -310px
    z-index 1
    use
      background red
</style>